export default __webpack_public_path__ + "static/media/chefus.ba7c6b38.png";